"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const _ = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
// gets largest state and then checks if there are ties
// returns all tied largest states. very unlikely there's more than 1
const getLargestStates = (concentrationReceivables) => {
    if (!concentrationReceivables.length) {
        return new Set();
    }
    const sortedEligibleExposureByState = (0, remeda_1.pipe)(concentrationReceivables, (0, remeda_1.groupBy)((receivable) => {
        (0, common_1.finleyAssert)(_.isString(receivable.baseFields.state), 'baseFields.state must be defined to run bmgMoneyAtlasSp1.otherStates');
        return receivable.baseFields.state;
    }), (0, remeda_1.mapValues)((receivables, state) => {
        const totalEligibleExposure = _.sumBy(receivables, (receivable) => receivable.eligibilityFields.eligibleExposure);
        return {
            state,
            totalEligibleExposure,
        };
    }), remeda_1.values, (0, remeda_1.sortBy)([
        (el) => el.totalEligibleExposure,
        'desc',
    ]));
    const largestStates = new Set([
        sortedEligibleExposureByState[0].state,
    ]);
    const largestEligibleExposure = sortedEligibleExposureByState[0].totalEligibleExposure;
    _.forEach(sortedEligibleExposureByState, (state) => {
        if (state.totalEligibleExposure === largestEligibleExposure) {
            largestStates.add(state.state);
        }
    });
    return largestStates;
};
exports.concentrationLimitPointerMethods = [
    {
        // receivables tied to any state that isn't the top state (in terms of the overall receivables) is limited to a total of 12 percent
        method: 'bmgMoneyAtlasSp1.otherStates',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit bmgMoneyAtlasSp1.otherStates`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const largestStates = getLargestStates(concentrationReceivables);
            if (largestStates.size === 0) {
                return {
                    kickouts: {},
                    calculations: {
                        concentrationLimit,
                        concentrationAmount: 0,
                        concentration: 0,
                    },
                };
            }
            // Filter for states that are not the top state
            const filteredReceivables = _.filter(concentrationReceivables, (rec) => {
                (0, common_1.finleyAssert)(_.isString(rec.baseFields.state), 'baseFields.state must be defined to run bmgMoneyAtlasSp1.otherStates');
                return !largestStates.has(rec.baseFields.state);
            });
            // Group by state
            const groupedReceivables = _.groupBy(filteredReceivables, (rec) => rec.baseFields.state);
            const standardBorrowingBaseReductions = _.map(_.values(groupedReceivables), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        result[finleyReceivableId] = 0;
                    }
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    {
        // receivables tied to any employer other than USPS, are limited to a total of 15%
        method: 'bmgMoneyAtlasSp1.otherEmployers',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit bmgMoneyAtlasSp1.otherEmployers`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            (0, common_1.finleyAssert)(_.every(concentrationReceivables, (rec) => _.isString(rec.baseFields.agency)), 'baseFields.agency must be defined to run bmgMoneyAtlasSp1.otherEmployers');
            // USPS agency string in the loan tape
            const uspsAgency = 'United States Postal Service';
            // Filter for states that are not the top state
            const filteredReceivables = _.filter(concentrationReceivables, (rec) => rec.baseFields.agency !== uspsAgency);
            // Group by agency
            const groupedReceivables = _.groupBy(filteredReceivables, (rec) => rec.baseFields.agency);
            const standardBorrowingBaseReductions = _.map(_.values(groupedReceivables), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        result[finleyReceivableId] = 0;
                    }
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map